import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2,jkLib,dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Syskc } from '../entity/Syskc-angular';

export interface SyskcData {     COMPANY: string ;     CREATOR: string;     USR_GROUP: string ;     CREATE_DATE: string;     MODIFIER: string;     MODI_DATE: string;     FLAG: number;     KC001: string;            // 日期 8     KC002: string;            // 時間 4     KC003: string;            // 簽收人 10 員工代號    KC004: string;            // 我要回應 255     KC005: Date;            // 簽收時間 0     KC006: string;            // 發佈人回覆 255 }


@Injectable({
  providedIn: 'root'
})
export class SyskcServicePkg extends JkEntityV2 { 


  constructor() {
    super();
    this.linkMasterFields = '' ; 
    this.defaultItem = new Syskc(); 
    this.entityType.type = EntityType.master;
    this.columnLabel = { COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數', 
        KC001 : '日期' , KC002 : '時間' , KC003 : '簽收人' , KC004 : '我要回應' , KC005 : '簽收時間' , KC006 : '發佈人回覆'  }; 

    this.fieldNames = 'KC001,KC002,KC003,KC004,KC005,KC006' ;
    this.fieldLengths = {KC001 : 8 ,KC002 : 4 ,KC003 : 10 ,KC004 : 255 ,KC005 : 0 ,KC006 : 255 } ;
    this.columnDefs = [
      { field: "KC001", headerName: "日期",headerTooltip: "",width:120,cellDataType: "text", valueFormatter: dateFormatter,  },
      { field: "KC002", headerName: "時間",headerTooltip: "",width:102,cellDataType: "text", },
      { field: "KC003", headerName: "簽收人",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "KC004", headerName: "我要回應",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "KC005", headerName: "簽收時間",headerTooltip: "",width:80,cellDataType: "date", valueFormatter: (p:any) => { return jkLib.datetimeFormatter(p.value)},  },
      { field: "KC006", headerName: "發佈人回覆",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'SYSKC' ;
    this.isSys =false; 
    this.sqlSelect = `SELECT SYSKC.*  FROM SYSKC` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1` ;
    this.sqlOrderDefault = ` ORDER BY KC001,KC002,KC003` ;
    this.keyFields = ['KC001','KC002','KC003'];
    this.url = '/db/crud'; 
    this.rememberFields = [];
    this.requiredFields = ['KC001','KC002','KC003'];
    this.seqField = '' ;
    this.seqFieldLength = 0 ;
  }
  override async validateItem(item: Syskc): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem:Syskc): Promise<Syskc> {
  await  super.newRecord(newItem);
    return newItem;
  }




}

